import { isLocalUrl } from '../util/local';
import type { SubsystemId} from './subsystemData';
import { subsystems } from './subsystemData';

export function subsystemEnvName(subsystem: SubsystemId) {
  return (
    subsystems[subsystem].envVarName ??
    subsystem.replace('-', '_').toUpperCase() + '_MS_HOST'
  );
}

export function subsystemShortName(subsystem: SubsystemId) {
  return subsystems[subsystem].shortName ?? subsystem;
}

export function isDefaultLocal(subsystem: SubsystemId) {
  return subsystems[subsystem].defaultLocal ?? false;
}

interface UrlVariable {
  name: string;
  scheme: string;
}

export function subsystemUrlVariables(subsystem: SubsystemId): UrlVariable[] {
  return [{ name: subsystemEnvName(subsystem), scheme: 'https' }];
}

export function allSubsystemIds(): SubsystemId[] {
  return Object.keys(subsystems) as SubsystemId[];
}

export function subsystemMayRunLocally(subsystem: SubsystemId): boolean {
  return subsystems[subsystem].port !== undefined || subsystems[subsystem].wsPort !== undefined;
}

export function configuredToRunLocally(subsystem: SubsystemId) {
  const url = process.env[subsystemEnvName(subsystem)];
  if (url == null) {
    return false;
  }

  return isLocalUrl(process.env, url);
}
